import script from "./LoginIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginIndex.vue?vue&type=script&setup=true&lang=js"

import "./LoginIndex.vue?vue&type=style&index=0&id=4fc7a065&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc7a065"]])

export default __exports__